import type { SoftwareComment } from "@/types";

export const commentPool: SoftwareComment[] = [
  {
    id: "c-1",
    user: "数码小白",
    avatar:
      "https://readdy.ai/api/search-image?query=Cute%20flat%20avatar%20illustration%20of%20friendly%20young%20person%20with%20glasses%2C%20soft%20blue%20background%2C%20minimal%20modern%20style%2C%20clean%20high%20quality%20vector%20portrait&width=120&height=120&seq=avatar-c1&orientation=squarish",
    rating: 5,
    date: "2026-10-06",
    content: "用了好几年了，版本更新很及时，功能也越来越全，日常使用完全离不开，强烈推荐给大家。",
  },
  {
    id: "c-2",
    user: "科技宅小周",
    avatar:
      "https://readdy.ai/api/search-image?query=Flat%20avatar%20illustration%20of%20tech%20savvy%20young%20man%20with%20headphones%2C%20warm%20orange%20background%2C%20minimal%20modern%20style%2C%20clean%20high%20quality%20vector%20portrait&width=120&height=120&seq=avatar-c2&orientation=squarish",
    rating: 4,
    date: "2026-10-05",
    content: "整体体验不错，界面清爽没有多余广告。就是希望后续能再优化一下低配手机的流畅度。",
  },
  {
    id: "c-3",
    user: "爱生活的小敏",
    avatar:
      "https://readdy.ai/api/search-image?query=Flat%20avatar%20illustration%20of%20cheerful%20young%20woman%20with%20short%20hair%2C%20soft%20green%20background%2C%20minimal%20modern%20style%2C%20clean%20high%20quality%20vector%20portrait&width=120&height=120&seq=avatar-c3&orientation=squarish",
    rating: 5,
    date: "2026-10-04",
    content: "功能很实用，新手引导也做得很贴心，家里长辈用起来都毫无压力，好评。",
  },
  {
    id: "c-4",
    user: "老张同学",
    avatar:
      "https://readdy.ai/api/search-image?query=Flat%20avatar%20illustration%20of%20middle%20aged%20friendly%20man%20with%20beard%2C%20calm%20blue%20gray%20background%2C%20minimal%20modern%20style%2C%20clean%20high%20quality%20vector%20portrait&width=120&height=120&seq=avatar-c4&orientation=squarish",
    rating: 4,
    date: "2026-10-02",
    content: "更新说明写得很清楚，看得出开发团队在认真维护。希望继续稳定更新，别突然停更。",
  },
  {
    id: "c-5",
    user: "加班到深夜",
    avatar:
      "https://readdy.ai/api/search-image?query=Flat%20avatar%20illustration%20of%20tired%20office%20worker%20with%20coffee%2C%20soft%20purple%20background%2C%20minimal%20modern%20style%2C%20clean%20high%20quality%20vector%20portrait&width=120&height=120&seq=avatar-c5&orientation=squarish",
    rating: 5,
    date: "2026-10-01",
    content: "效率提升太明显了，之前要折腾半天的事情现在几步就搞定，真的省心。",
  },
  {
    id: "c-6",
    user: "手游十级玩家",
    avatar:
      "https://readdy.ai/api/search-image?query=Flat%20avatar%20illustration%20of%20energetic%20gamer%20boy%20with%20cap%2C%20vibrant%20red%20background%2C%20minimal%20modern%20style%2C%20clean%20high%20quality%20vector%20portrait&width=120&height=120&seq=avatar-c6&orientation=squarish",
    rating: 4,
    date: "2026-09-30",
    content: "玩法很上头，匹配速度也快。要是再优化下发热和耗电就更完美了。",
  },
  {
    id: "c-7",
    user: "旅行摄影控",
    avatar:
      "https://readdy.ai/api/search-image?query=Flat%20avatar%20illustration%20of%20young%20traveller%20with%20camera%2C%20sky%20blue%20background%2C%20minimal%20modern%20style%2C%20clean%20high%20quality%20vector%20portrait&width=120&height=120&seq=avatar-c7&orientation=squarish",
    rating: 5,
    date: "2026-09-28",
    content: "信息很全面，出行前查一查特别方便，界面排版也比同类应用舒服很多。",
  },
  {
    id: "c-8",
    user: "家庭主妇莉莉",
    avatar:
      "https://readdy.ai/api/search-image?query=Flat%20avatar%20illustration%20of%20warm%20friendly%20mother%20smiling%2C%20soft%20pink%20background%2C%20minimal%20modern%20style%2C%20clean%20high%20quality%20vector%20portrait&width=120&height=120&seq=avatar-c8&orientation=squarish",
    rating: 5,
    date: "2026-09-26",
    content: "操作简单，优惠也挺实在，日常用得多。希望客服响应速度还能再快一点。",
  },
  {
    id: "c-9",
    user: "程序员小林",
    avatar:
      "https://readdy.ai/api/search-image?query=Flat%20avatar%20illustration%20of%20young%20developer%20with%20hoodie%2C%20dark%20teal%20background%2C%20minimal%20modern%20style%2C%20clean%20high%20quality%20vector%20portrait&width=120&height=120&seq=avatar-c9&orientation=squarish",
    rating: 4,
    date: "2026-09-24",
    content: "细节打磨得不错，功能逻辑清晰。如果能把设置项再归类整理一下会更顺手。",
  },
  {
    id: "c-10",
    user: "学生党阿凯",
    avatar:
      "https://readdy.ai/api/search-image?query=Flat%20avatar%20illustration%20of%20cheerful%20student%20boy%20with%20backpack%2C%20fresh%20yellow%20background%2C%20minimal%20modern%20style%2C%20clean%20high%20quality%20vector%20portrait&width=120&height=120&seq=avatar-c10&orientation=squarish",
    rating: 5,
    date: "2026-09-22",
    content: "免费好用，功能完全够用，同学之间都在推荐，装了就舍不得卸载的类型。",
  },
];